// extracted by mini-css-extract-plugin
export default {"error":"Messages_error__SaTmz","success":"Messages_success__PEsIS"};